import { ControlElement } from './ControlElement';
import { TeaBlocksError } from './../../TeaBlocksError';
import { ControlType } from './ControlType';
import { VoidBlock } from "../VoidBlock";
import { ReturnBlock } from '../ReturnBlock';

/**
 * Like the MakeShapeBlock. Creates and assigns an a ControlElement object to 
 * $elemName in the varEnv. Does not draw the variable itself.
 */
export class MakeControlElementBlock extends VoidBlock {
    x: ReturnBlock;
    y: ReturnBlock;
    elemName: string;
    type: ControlType;

    /**
     * Constructor.
     * @param id id of statenode
     * @param type the type of ui element
     * @param elemName the display name of the ui element (what user specifies)
     * @param inputs inputs[0] is x; input[1] is y
     */
    constructor(id: string, type: ControlType, elemName: string, inputs: ReturnBlock[]) {
        super(id);
        this.type = type;
        this.elemName = elemName;
        this.x = inputs[0];
        this.y = inputs[1];
    }


    *evalBlock(varEnv: Map<string, any>) {
        let x = Number(this.x.evalBlock(varEnv));
        let y = Number(this.y.evalBlock(varEnv));

        if (isNaN(x) || isNaN(y)) throw new TeaBlocksError('Position must be a number', this.id);

        let elem = new ControlElement(this.elemName, x, y, this.type);

        varEnv.set('$' + this.elemName, elem);
        yield;
    }

}